import React from 'react';

import {configuredRadium} from '../utils/General';
import PropTypes from 'prop-types';

import withRadiumStyleRoot from './withRadiumStyleRoot';

const styles = {
  noStyleButton: {
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
  },
  wrapper: {
    position: 'relative',
    width: 'calc(100% - 4px)',
    '@media screen and (max-width: 768px)': {
      width: '100%',
    },
    marginLeft: '3px',
  },
  wrapperOrange: {
    border: '1px solid rgb(4, 62, 92)',
  },
  wrapperWhite: {
    border: '1px solid #FFFFFF',
  },
  button: {
    height: '50px',
    fontSize: '18px',
    width: '100%',
    textTransform: 'inherit',
    transform: 'translate(-6px, -6px)',
    '@media screen and (max-width: 768px)': {
      transform: 'translate(-6px, -6px)',
    },
    ':active': {
      transform: 'translate(-6px, -6px)',
    },
  },
  activeButton: {
    transform: 'translate(0px,0px)',
    '@media screen and (max-width: 768px)': {
      transform: 'translate(0px,0px)',
    },
  },
  orangeButton: {
    backgroundColor: 'rgb(4, 62, 92)',
    color: '#FFFFFF',
    ':active': {
      backgroundColor: 'rgb(4, 62, 92)',
    },
    '.active': {
      backgroundColor: 'rgb(4, 62, 92)',
    },
  },
  orangeActiveButton: {
    backgroundColor: 'rgb(4, 62, 92)',
  },
  whiteActiveButton: {
    backgroundColor: '#F9FBFF',
  },
  whiteButton: {
    backgroundColor: '#FFFFFF',
    color: 'rgb(4, 62, 92)',
    border: '1px solid rgb(4, 62, 92)',
    ':active': {
      backgroundColor: '#F9FBFF',
    },
    'active': {
      backgroundColor: '#F9FBFF',
    },
  },
};

const SubmitButton = ({wrapperStyles, text, handleClick, color, active, buttonId}) => {
  const buttonStyles = [styles.button, (color === 'orange' ? styles.orangeButton : styles.whiteButton)];
  const activeButtonColor = color === 'orange' ? styles.orangeActiveButton : styles.whiteActiveButton;
  if (active) {
    buttonStyles.push(styles.activeButton, activeButtonColor);
  }

  return (
    <div
      style={[styles.wrapperOrange, styles.wrapper, wrapperStyles]}
    >
      <button
        type="button"
        style={[styles.noStyleButton, buttonStyles]}
        onClick={() => {
          if (!active) {
            handleClick();
          }
        }}
        disabled={active}
        id={buttonId}
      >
        {text}
      </button>
    </div>
  );
};

SubmitButton.propTypes = {
  wrapperStyles: PropTypes.object,
  text: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  color: PropTypes.string,
  active: PropTypes.bool,
  buttonId: PropTypes.string
};

SubmitButton.defaultProps = {
  wrapperStyles: {},
  color: 'orange',
  active: false,
  buttonId: ''
};

export default withRadiumStyleRoot(configuredRadium(SubmitButton));



// WEBPACK FOOTER //
// ./src/components/SubmitButton.jsx